$(function () {
  TCPlayer("videoPlayer", {
    fileID: "5285890790414971705",
    appID: "1252076093",
    autoplay: false,
  });
  TCPlayer("videoPlayerT", {
    fileID: "5285890795380695554",
    appID: "1259605108",
    autoplay: false,
  });

//   控制弹窗的显示
  function showEle(e){
    $(e).click(function(){
        $(".yuyue").show();
      })
  }
  showEle(".more_btn")
  showEle(".dingzhi_btn")
  showEle(".yuyue_btn")
  showEle(".fangan_btn")

// 表格切换

function tableEle(e,t){
    $(e).hover(function () {
        $(t).eq($(this).index()).show().siblings().hide();
        $(this).children(".txt").hide().next().show();
        $(this).siblings().children(".pic").hide().prev().show();
      });
}
tableEle("#firstNav .nav_list","#zkhTable .table_list")
tableEle("#secondNav .nav_list","#ygkTable .table_list")
tableEle("#thirdNav .nav_list","#wgkTable .table_list")
//   中间预约
  $(".class_list .class_name").click(function () {
    $(".down_list").hide();
    $(this).siblings(".down_list").show();
  });
  $(".class_list .down_list .option").click(function () {
    $(this)
      .parent()
      .siblings(".class_name")
      .text($(this).text())
      .siblings(".hidden_input")
      .val($(this).text());
    $(this).parent().hide();
  });
  
  $(".hidden_icon").click(function () {
    $(".yuyue").hide();
  });
  $(".guanbi").click(function () {
    $(".form").hide();
  });


  $(".yuyue_content").listenFormS({
    contentName: [
      {
        search: "?jtppzq",
        name: " PC中高考弹窗（百品）",
      },
      {
        search: "?360jtppzq",
        name: "PC中高考弹窗（360）",
      },
      {
        search: "",
        name: " PC中高考弹窗",
      },
    ],
    submitTarget: ".baomin_btn",
    courseRequired: true,
    cityRequired: true,
    emailRequired: true,
  });
//   底部预约
  $(".select-one .option").click(function(){
    $(".couse01").val($(this).text())
    $(this).parent().siblings(".current").text($(this).text())
  })
  $(".select-city .option").click(function(){
    $(".city03").val($(this).text())
    $(this).parent().siblings(".current").text($(this).text())
  })

  $(".form").listenForm({
    contentName: [
      {
        search: "?jtppzq",
        name: " PC中高考底部（百品）",
      },
      {
        search: "?360jtppzq",
        name: "PC中高考底部（360）",
      },
      {
        search: "",
        name: " PC中高考底部",
      },
    ],
    submitTarget: "#submitBtn2",
    courseRequired: true,
    cityRequired: true
  });
});
